export const urls = {
  BT: 'https://bluetape.com',
  TC: 'https://www.bluetape.com/terms-conditions/',
  PP: 'https://www.bluetape.com/privacy-policy/',
}
